/**
 * Multi-step Form Navigation Component
 * Handles navigation between form steps
 */

'use strict';

var twentyninetimesCustomForm = twentyninetimesCustomForm || {};

twentyninetimesCustomForm.MultiStepNavigation = {
    /**
     * Handle navigation to the next step in a multi-step form
     * @param {HTMLElement} formular - The form element
     * @param {HTMLElement} submitBtn - The submit button that was clicked
     * @param {HTMLElement} currentContainer - The current step container
     * @returns {boolean} true if moved to next step, false if this is the final step
     */
    moveToNextStep: function(formular, submitBtn, currentContainer) {
        if (!formular.classList.contains('form-has-steps')) {
            return false; // Not a multi-step form
        }

        currentContainer.classList.add('validated');
        const nextContainer = twentyninetimesCustomForm.ConditionalLogic
            ? twentyninetimesCustomForm.ConditionalLogic.getNextAvailableStep(currentContainer)
            : currentContainer.nextElementSibling;
        
        if (nextContainer && nextContainer.classList.contains('customform-field-container')) {
            const nextBtnText = nextContainer.getAttribute('data-step-btn-text');
            
            // Hide current step
            currentContainer.style.display = 'none';
            currentContainer.classList.add('hidden');
            currentContainer.classList.remove('current');
            
            // Update button text if specified
            if (nextBtnText) {
                submitBtn.innerText = nextBtnText;
            }
            
            // Show next step
            nextContainer.style.display = 'block';
            nextContainer.classList.remove('hidden');
            nextContainer.classList.add('current');
            
            // Scroll to next step
            if (twentyninetimesCustomForm.ScrollUtils) {
                twentyninetimesCustomForm.ScrollUtils.scrollToElement(nextContainer);
            }
            
            return true; // Moved to next step
        }
        
        return false; // This was the final step
    },

    /**
     * Get the current step container in a multi-step form
     * @param {HTMLElement} formular - The form element
     * @returns {HTMLElement|null} The current step container or null
     */
    getCurrentStepContainer: function(formular) {
        if (formular.classList.contains('form-has-steps')) {
            return formular.querySelector('.customform-field-container.current');
        } else {
            return formular.querySelector('.customform-field-container');
        }
    }
};
